module.exports = __webpack_public_path__ + "9fc9c2268a74092f10f613d31a96f487.MP3";